<template>
    <v-layout column align-center>
        <template v-if="isGranted == null">
            <employees-item-grant-confirm v-bind="{ value, program, isUserHost }" v-on="{ input }">
                <template #activator="{ attrs, on }">
                    <v-btn small outlined width="100" color="primary" v-bind="attrs" v-on="on">
                        <span> 승인요청 </span>
                    </v-btn>
                </template>
            </employees-item-grant-confirm>
        </template>

        <template v-if="isGranted == true">
            <v-btn small width="100" color="secondary lighten-5">
                <span class="secondary--text"> 승인완료 </span>
            </v-btn>
        </template>

        <template v-if="isGranted == false">
            <v-btn small width="100" color="grey-ec">
                <span class="grey--text"> 승인거부 </span>
            </v-btn>
        </template>
    </v-layout>
</template>

<script>
import { initExpoProgram, initExpoEmployee } from "@/assets/variables";

import EmployeesItemGrantConfirm from "./employees-item-grant-confirm.vue";

export default {
    components: {
        EmployeesItemGrantConfirm,
    },
    props: {
        value: { type: Object, default: initExpoEmployee },
        program: { type: Object, default: initExpoProgram },
        isUserHost: { type: Boolean, default: false },
    },
    computed: {
        isGranted() {
            return this.value.isGranted;
        },
    },
    methods: {
        input(employee) {
            this.$emit("input", employee);
        },
    },
};
</script>

<style>
</style>